import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/deducciones-tipos-de-nominas';

/**
 * GET Deducciones Tipos de Nominas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDeduccionesTiposDeNominas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Deduccion Tipo de Nomina
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDeduccionTipoDeNomina = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Deduccion Tipo de Nomina
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDeduccionTipoDeNomina = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Deduccion Tipo de Nomina
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDeduccionTipoDeNomina = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Deduccion Tipo de Nomina
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDeduccionTipoDeNomina = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
